/**
 * Images size.
 */
export const BASE_IMAGE_SIZE = 2000;

/**
 * Main group containing product placements.
 */
export const GROUP_PRODUCT = 'Product';

/**
 * Main placement containing the product ID.
 */
export const PLACEMENT_PRODUCT = 'Product';

/**
 * Main placement defining color gallery.
 */
export const PLACEMENT_COLORS = 'Colors';

/**
 * Prefix of placements with images.
 */
export const PLACEMENT_IMAGE = 'Image';

/**
 * Image gallery placement.
 */
export const PLACEMENT_IMAGE_GALLERY = 'ImageGallery';

/**
 * Prefix of placements with base embellishments group.
 */
export const PLACEMENT_EMBELLISHMENTS_BASE = 'EmbellishmentsBase';

/**
 * Prefix of placements with base embellishments group.
 */
export const PLACEMENT_EMBELLISHMENTS = 'Embellishments';

/**
 * Prefix of placements with text.
 */
export const PLACEMENT_TEXT = 'Text';

/**
 * Prefix of placements with monogram.
 */
export const PLACEMENT_MONOGRAM = 'Monogram';

/**
 * Prefix of product components.
 */
export const COMPONENT_PRODUCT = 'PRODUCT-';

/**
 * Names of the definition with product options.
 */
export const DEFINITION_PRODUCT = 'Product';

/**
 * Names of the definition with color options.
 */
export const DEFINITION_COLOR = 'Color';

/**
 * Names of the definition with font options.
 */
export const DEFINITION_FONT = 'Font';

/**
 * Names of the definition with monogramming options.
 */
export const DEFINITION_MONOGRAM = 'Monogram';

/**
 * Printing customization method.
 */
export const METHOD_PRINTING = 'printing';

/**
 * Etching customization method.
 */
export const METHOD_ETCHING = 'etching';

/**
 * Standard DPI setting.
 */
export const STANDARD_DPI = 72;

/**
 * Standard DPI setting.
 */
export const STANDARD_PIXELS = 300;

/**
 * Angular snapping tolerance.
 */
export const SNAP_TOLERANCE = 14;

/**
 * Snap angles.
 */
export const SNAP_ANGLE = 90;

/**
 * Minimum vector rasterization size.
 */
export const MIN_RASTER_WIDTH = 2000;

/**
 * Minimum vector rasterization size.
 */
export const MIN_RASTER_HEIGHT = 1000;

export const TOP_NAV_HEIGHT = 96;

export const DESKTOP_BREAKPOINT = 900;
